import React from 'react';
import { decrypt, URL } from '../variables';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { login } from '../actions/AppActions';
import moment from 'moment';
import CandidateLanguageSelector from '../components/CandidateLanguageSelector';
import { getLanguageTexts, getSelectedLanguage } from '../language';
import { CandidateValidationNotice } from '../Home/CandidateUi';
// import './alert.css';

class Login extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            faculdade: null,
            loading: false,
            msgErro: '',
            credencial: '',
            password: '',
            redirect: false,
            loading_login:false,
            showPassword: false,
            path: '',
            selectedLanguage: getSelectedLanguage()
        }

    }

    handleLanguageChange = (event) => {
        this.setState({ selectedLanguage: event.detail || getSelectedLanguage() });
    }

    login(event) {
        event.preventDefault();
        let faculdade_id = null;
        if (this.state.faculdade != null) {
            faculdade_id = this.state.faculdade.id;
        }
        this.setState({loading_login:true,msgErro:''});
        fetch(`${URL}api/auth/login?v=a`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                // 'Authorization': `Bearer ${this.props.token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                credencial: this.state.credencial,
                password: this.state.password,
                faculdade_id
            })
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                resp = decrypt(resp);
                
                console.log(resp)
                if(resp.message == 'Server Error'){
                    this.timeout = setTimeout(()=>{
                        this.login(event)
                    },5000);
                    return;
                }
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);

                    this.setState({ loading: false, msgErro: erro, refresh: false, loadingMore: false,loading_login:false });
                }
                else {
                    localStorage.setItem('token', resp.access_token);
                    this.props.login({ token: resp.access_token, user: {} });
                    // this.setState({ redirect: true, path: '/home', loading: false });
                    // if (resp.faculdade != null) {
                    //     this.setState({ faculdade: resp.faculdade, loading: false, msgErro: '' });
                    // }
                    // else {
                    //     this.setState({ redirect: true, path: '/', loading: false });
                    // }
                    // this.setState({ loading: false, refresh: false, loadingMore: false, msgErro: '' });

                }




            } catch (err) {
                console.log(err);
                this.setState({ loading: false, msgErro: getLanguageTexts(this.state.selectedLanguage).server_response_error, refresh: false, loadingMore: false,loading_login:false });

            }

        })
            .catch((err) => {
                console.log(err);
                this.setState({ loading: false, msgErro: getLanguageTexts(this.state.selectedLanguage).internet_connection_error, refresh: false, loadingMore: false,loading_login:false });
            });
    }

    get_faculdade(slug) {
        fetch(`${URL}api/get_faculdade/${slug}?v=a`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                // 'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                resp = decrypt(resp);
                console.log(resp);
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);

                    this.setState({ loading: false, msgErro: erro, });
                }
                else {
                    if (resp.faculdade != null) {
                        this.setState({ faculdade: resp.faculdade, loading: false, msgErro: '' });
                    }
                    else {
                        this.setState({ redirect: true, path: '/', loading: false });
                    }
                    // this.setState({ loading: false, refresh: false, loadingMore: false, msgErro: '' });

                }




            } catch (err) {
                console.log(err);
                this.setState({ loading: false, msgErro: getLanguageTexts(this.state.selectedLanguage).server_response_error, });

            }

        })
            .catch((err) => {
                console.log(err);
                this.setState({ loading: false, msgErro: getLanguageTexts(this.state.selectedLanguage).internet_connection_error, });
            });
    }

    componentDidMount() {
        const { match: { params } } = this.props;
        window.addEventListener('candidate_language_change', this.handleLanguageChange);
        this.setState({ loading: true, msgErro: '' });
        this.get_faculdade(params.slug);
    }


    changeCPF(event) {
        let text = event.target.value
        let final_num = '';

        if (text.length > 0) {
            text = text.replace('.', '').replace('-', '').replace('.', '');
            if (text.length <= 11) {


                for (let i = 0; i < text.length; i++) {
                    if (!isNaN(text[i])) {
                        if (i == 3) {
                            final_num += '.' + text[i];
                        }
                        else if (i == 6) {
                            final_num += '.' + text[i];
                        }
                        else if (i == 9) {
                            final_num += '-' + text[i];
                        }
                        else {
                            final_num += text[i] + '';
                        }
                    }
                }
                // this.setState({ cpf: final_num });
                this.setState({ credencial: final_num })
            }

        }
        else {
            this.setState({ credencial: final_num })
        }


    }

    changeEmail(event) {
        let text = event.target.value
        let final_num = '';
        final_num = text;
        this.setState({ credencial: final_num })
    }

    changeCPFEmail(event) {
        let text = event.target.value
        let final_num = '';
        if (text.length > 0 && isNaN(text[0])) {
            final_num = text;
            this.setState({ credencial: final_num })
        }
        else if (text.length > 0) {
            text = text.replace('.', '').replace('-', '').replace('.', '');
            if (text.length <= 11) {


                for (let i = 0; i < text.length; i++) {
                    // if (Number.isInteger(text[i])) {
                    if (i == 3) {
                        final_num += '.' + text[i];
                    }
                    else if (i == 6) {
                        final_num += '.' + text[i];
                    }
                    else if (i == 9) {
                        final_num += '-' + text[i];
                    }
                    else {
                        final_num += text[i] + '';
                    }
                    // }
                }
                // this.setState({ cpf: final_num });
                this.setState({ credencial: final_num })
            }

        }
        else {
            this.setState({ credencial: final_num })
        }


    }

    changePassword(event) {
        this.setState({ password: event.target.value })
    }

    componentWillUnmount(){
        window.removeEventListener('candidate_language_change', this.handleLanguageChange);
        clearTimeout(this.timeout);
    }

    render() {
        const t = getLanguageTexts(this.state.selectedLanguage);
        return (
            <div className="candidate-login-page">
                {this.state.redirect == true && <Redirect to={this.state.path} />}
                {this.state.loading && <div className="candidate-auth-loading"> <div className="spinner-border text-primary" role="status"  >
                    <span className="sr-only">{t.loading}</span>
                </div></div>}
                {!this.state.loading && this.state.faculdade != null && <div className="candidate-login-layout">
                    <section className="candidate-login-panel">
                        <div className="candidate-login-form-wrap">
                                <div className="candidate-login-logo">
                                    <img src={this.state.faculdade.logo || require('../assets/images/logo-ontest.png')}
                                        alt={this.state.faculdade.name || "OnTest"} />
                                </div>

                                <div className="candidate-login-form">
                                    <span className="candidate-auth-kicker">{t.candidate_environment}</span>
                                    <h1>{t.welcome}</h1>
                                    <p>{t.login_subtitle}</p>

                                    <form className="form-horizontal m-t-30" onSubmit={this.login.bind(this)}>

                                        <div className="form-group row candidate-auth-field" >
                                            {this.state.faculdade.type_login == 'all' && <div className="col-12">
                                                <label>{t.cpf_or_email} <span>*</span></label>
                                                <input id="credencial" type="username"
                                                    className="form-control" name="credencial" placeholder={t.type_cpf_or_email}
                                                    value={this.state.credencial} onChange={this.changeCPFEmail.bind(this)} required autoComplete="email" autoFocus />

                                            </div>}


                                            {this.state.faculdade.type_login == 'cpf' && <div className="col-12">
                                                <label>{t.cpf} <span>*</span></label>
                                                <input id="credencial" type="username"
                                                    className="form-control" name="credencial" placeholder={t.type_cpf}
                                                    value={this.state.credencial} onChange={this.changeCPF.bind(this)} required  autoFocus />

                                            </div>}

                                            {this.state.faculdade.type_login == 'email' && <div className="col-12">
                                                <label>{t.email} <span>*</span></label>
                                                <input id="credencial" type="username"
                                                    className="form-control" name="credencial" placeholder={t.type_email}
                                                    value={this.state.credencial} onChange={this.changeEmail.bind(this)} required autoComplete="email" autoFocus />

                                            </div>}

                                        </div>

                                        <div className="form-group row candidate-auth-field" >
                                            <div className="col-12">
                                                <label>{t.password} <span>*</span></label>
                                                <div className="candidate-password-field">
                                                <input id="password" type={this.state.showPassword ? "text" : "password"}
                                                    value={this.state.password}
                                                    onChange={this.changePassword.bind(this)}
                                                    className="form-control" name="password" placeholder={t.type_password}
                                                    required autoComplete="current-password" />
                                                <button type="button" aria-label={this.state.showPassword ? t.hide_password : t.show_password} onClick={() => this.setState({ showPassword: !this.state.showPassword })}>
                                                    <i className={this.state.showPassword ? "mdi mdi-eye-off" : "mdi mdi-eye"}></i>
                                                </button>
                                                </div>


                                                {this.state.faculdade != null && this.state.faculdade.texto_login != null && <span className="candidate-login-help" role="alert" >
                                                    {this.state.faculdade.texto_login}
                                                </span>}
                                            </div>

                                        </div>

                                        {this.state.faculdade.reset_password==true && <div className="form-group m-t-0 mb-0 row candidate-reset-link">
                                            <div className="col-12" >
                                                {<a target="_blank" href={this.state.faculdade.reset_password_link} className="text-primary" style={{fontWeight:'bold',fontSize:14}}>
                                                    {this.state.faculdade.reset_password_text}
                                                </a>}
                                            </div>
                                        </div>}
                                        <div className="form-group row m-t-20 candidate-login-action">
                                            {this.state.msgErro != '' && <div className="col-sm-12">
                                                <CandidateValidationNotice tone="danger">{this.state.msgErro}</CandidateValidationNotice>
                                            </div>}
                                            <div className="col-sm-12 text-right">
                                            {this.state.loading_login==false && <button className="btn btn-primary w-md waves-effect waves-light" style={{ backgroundColor: this.state.faculdade != null ? this.state.faculdade.primaria : '' }} type="submit">{t.enter} <i className="mdi mdi-arrow-right"></i></button>}
                                                {this.state.loading_login==true && <div style={{width:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}>
                                                <div className="spinner-border text-primary" role="status"  >
                                                </div>
                                                </div>}

                                            </div>
                                        </div>

                                    </form>
                                </div>
                                <div className="candidate-login-footer">
                                    <p>© {moment().format('YYYY')} OnTest</p>
                                    <CandidateLanguageSelector className="candidate-login-language" />
                                </div>
                        </div>
                    </section>
                    <aside className="candidate-login-visual" style={{ backgroundImage: `url(${require("../assets/images/candidate-access-v2.png")})` }}>
                        <div className="candidate-login-visual-overlay"></div>
                        <div className="candidate-login-visual-copy">
                            <span>ONTEST</span>
                            <h2>{t.login_hero_title}</h2>
                            <p>{t.login_hero_description}</p>
                        </div>
                    </aside>
                </div>}
            </div>
        );
    }


}

const mapsStateToProps = (state) => (
    {
    }
);

export default connect(mapsStateToProps, { login })(Login);
